import React, { useContext, useEffect, useState } from 'react';
import { Link, Box, Breadcrumbs } from '@firsttable/web-components/atoms';
import MenuSidebar from '@firsttable/web-components/molecules/MenuSidebar';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import Button from '@components/analytics/components/Button';
import NavLinkComponent from '../GatsbyLinkConvertor';
import SilverstripeContext from '../context/Silverstripe';
import parseHtml from '../../lib/parseHtml';
import { comparePaths } from '../../lib/functions';
import SideBarLayout from '../layouts/SideBarLayout';
import { useAuthState } from '../context/AuthContext';
import { TrackProvider } from '../analytics/context/AnalyticsContext';

const FAQs = dynamic(() => import('../organisms/FAQs/FAQs'));

const PartnersContent = styled.div`
  .bg-pulse-animation {
    float: none !important;
    margin: 0 0 20px 0 !important;
    display: block;
  }

  .parsed-html-btn {
    display: block;
  }
`;

const SideBarButton = ({ href, title }) => (
  <TrackProvider button_name={title} button_type="navigation">
    <Button
      wide
      size="l"
      kind="outline"
      href={href}
      NavComponent={NavLinkComponent}
      mt={[20, 50]}
      noLinkTracking>
      {title}
    </Button>
  </TrackProvider>
);

const SideMenuLayout = () => {
  const {
    page: { children, parent, ...page },
  } = useContext(SilverstripeContext);
  const router = useRouter();
  const menuPages = parent ? parent.children.edges : children.edges;
  const { isLoggedIn } = useAuthState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (router.isReady) {
      setLoading(false);
    }
  }, [router.isReady]);

  const isFrequentFoodies = router.asPath && router.asPath.startsWith('/frequent-foodies');
  const isPartnersPage = page.slug?.endsWith('/partners');

  return (
    <SideBarLayout
      breadcrumbs={
        <TrackProvider component_name="breadcrumbs">
          <Breadcrumbs itemScope itemType="http://schema.org/BreadcrumbList">
            {page.breadcrumbs.edges.map(({ node }, i) => (
              <li
                key={node.id}
                itemScope
                itemProp="itemListElement"
                itemType="http://schema.org/ListItem">
                <TrackProvider link_name="breadcrumb">
                  <Link
                    to={node.slug}
                    NavComponent={NavLinkComponent}
                    itemProp="item"
                    active={comparePaths(router.asPath, node.slug)}>
                    <Box as="span" itemProp="name">
                      {node.menuTitle}
                    </Box>
                  </Link>
                </TrackProvider>
                <meta itemProp="position" content={i + 1} />
              </li>
            ))}
          </Breadcrumbs>
        </TrackProvider>
      }
      menu={
        <TrackProvider component_name="menu side bar">
          <MenuSidebar>
            {menuPages.map(({ node }) => (
              <li key={node.id}>
                <TrackProvider link_name="menu item">
                  <Link
                    NavComponent={NavLinkComponent}
                    to={node.slug}
                    active={comparePaths(router.asPath, node.slug)}>
                    {node.menuTitle}
                  </Link>
                </TrackProvider>
              </li>
            ))}
          </MenuSidebar>
          {isFrequentFoodies && (
            <Box opacity={loading ? 0 : 1}>
              {isLoggedIn ? (
                <SideBarButton title="My Frequent Foodies&reg;" href="/profile/frequent-foodies" />
              ) : (
                <SideBarButton title="Get Started" href="/profile/frequent-foodies" />
              )}
            </Box>
          )}
        </TrackProvider>
      }>
      {page.className === 'FAQPage' ? (
        <Box>
          <FAQs page={page} />
        </Box>
      ) : (
        <Box>
          {isPartnersPage ? (
            <PartnersContent>{parseHtml(page.content)}</PartnersContent>
          ) : (
            parseHtml(page.content)
          )}
        </Box>
      )}
    </SideBarLayout>
  );
};

SideMenuLayout.propTypes = {};

export default SideMenuLayout;
